import { useCallback, useEffect, useState } from 'react';

const isRTL = typeof document !== 'undefined' && document.dir === 'rtl';

/**
 * Determines whether there is scroll content in the table or not.
 */
export const useHasScrollContent = (element) => {
  const [hasScrollContent, setHasScrollContent] = useState(false);

  const getHasContentToScroll = useCallback(() => {
    const { scrollWidth, clientWidth, scrollLeft } = element || {};

    const offset = isRTL ? Math.abs(scrollLeft) : scrollLeft;

    return scrollWidth > clientWidth && offset + clientWidth < scrollWidth;
  }, [element]);

  const updateHasContentToScroll = useCallback(() => {
    setHasScrollContent(getHasContentToScroll());
  }, [getHasContentToScroll]);

  useEffect(() => {
    if (element) {
      // Sets `hasScrollContent` in the initial load.
      updateHasContentToScroll();

      element.addEventListener('scroll', updateHasContentToScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', updateHasContentToScroll);
      }
    };
  }, [element, updateHasContentToScroll]);

  useEffect(() => {
    window.addEventListener('resize', updateHasContentToScroll);

    return () => {
      return window.removeEventListener('resize', updateHasContentToScroll);
    };
  }, [updateHasContentToScroll]);

  return hasScrollContent;
};
